import thunk from 'redux-thunk'
import { createStore, applyMiddleware, compose } from 'redux'
import RootReducer from './reducers/RootReducer'
import localStorageService from '../services/localStorageService'

import throttle from 'lodash.throttle';

const {loadState, saveState} = localStorageService

const initialState = {
    ecommerce:{cartList:loadState('cartList')},
    
}
const middlewares = [thunk]
let devtools = (x) => x

if (
    process.env.NODE_ENV !== 'production' &&
    process.browser &&
    window.__REDUX_DEVTOOLS_EXTENSION__
) {
    devtools = window.__REDUX_DEVTOOLS_EXTENSION__()
}

export const Store = createStore(
    RootReducer,
    initialState,
    compose(applyMiddleware(...middlewares), devtools)
)

Store.subscribe(throttle(() => {
    saveState(
        "cartList",
        Store.getState().ecommerce.cartList,
       
    );
  }, 1000))
